module.exports = __webpack_public_path__ + "img/background.8426e282.png";